/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery, take, select } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { notificationContainer } from 'utils/notificationContainer';
import fileDownload from 'js-file-download';
import { PATHS } from 'routes/constants';
import {
	newIOSSVATReportRequest,
	newVATReportSuccess,
	newIOSSVATReportWithPaymentRequest,
	settingsInitState,
	vatReportFileRequest,
	vatReportFileSuccess,
	vatReportStatusRequest,
	vatReportStatusSuccess,
	vatReportFileZipRequest,
	vatReportFileZipSuccess,
	newNonUnionVATReportRequest,
	newNonUnionVATReportWithPaymentRequest,
	newNonUnionVATXmlReportRequest,
	newNonUnionVATXmlReportWithPaymentRequest,
	newUnionVATReportRequest,
	newUnionVATReportWithPaymentRequest,
	getVatReportsRequest,
	getVatReportsSuccess,
	swissPostVATReportRequest,
	swissPostVATReportSuccess,
	euDdpVATReportRequest,
	euDdpVATReportSuccess,
} from './reducer';
import {
	TNewVATReportFileTypes,
	TNewVATReportResponsePayload,
	TVatReportFileRequestPayload,
	TVatReportFileResponsePayload,
	TVatReportStatusRequestPayload,
	TVatReportStatusResponsePayload,
	TVatReportsResponsePayload,
	TSwissPostVATReportResponsePayload,
	TEuDdpVATReportResponsePayload,
} from './types';
import { newVatReportFileType } from './selectors';
import {
	NEW_IOSS_FILE_TYPE_ALL,
	NEW_IOSS_FILE_TYPE_WITH_PAYMENT,
	NEW_NON_UNION_FILE_TYPE_ALL,
	NEW_NON_UNION_FILE_TYPE_WITH_PAYMENT,
	NEW_NON_UNION_XML_FILE_TYPE_ALL,
	NEW_NON_UNION_XML_FILE_TYPE_WITH_PAYMENT,
	NEW_UNION_FILE_TYPE_ALL,
	NEW_UNION_FILE_TYPE_WITH_PAYMENT,
	NEW_SWISS_POST_FILE,
} from './constants';

const date = new Date();

function* newIOSSVATReportWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(api.vatreport.newVATReport);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

function* newIOSSVATReportWithPaymentWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(
			api.vatreport.newVATReportWithPayment,
		);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

function* newNonUnionVATReportWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(api.vatreport.newNonUnionVATReport);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

function* newNonUnionVATReportWithPaymentWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(
			api.vatreport.newNonUnionVATReportWithPayment,
		);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

function* newNonUnionVATXmlReportWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(
			api.vatreport.newNonUnionVATXmlReport,
		);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

function* newNonUnionVATXmlReportWithPaymentWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(
			api.vatreport.newNonUnionVATXmlReportWithPayment,
		);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

function* vatReportStatusWorker(action: PayloadAction<TVatReportStatusRequestPayload>) {
	const { payload } = action;
	try {
		const response: TVatReportStatusResponsePayload = yield call(
			api.vatreport.vatReportStatus,
			payload,
		);
		yield put(vatReportStatusSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(settingsInitState());
	}
}

function* vatReportFileWorker(action: PayloadAction<TVatReportFileRequestPayload>) {
	const { payload } = action;
	// const typeofFile = take(vatReportFileRequest);
	try {
		const state: TNewVATReportFileTypes = yield select(newVatReportFileType);
		const typeOfFile =
			state === NEW_IOSS_FILE_TYPE_WITH_PAYMENT
				? 'IOSS_VAT-report_with-payment'
				: state === NEW_IOSS_FILE_TYPE_ALL
					? 'IOSS_VAT-report'
					: state === NEW_NON_UNION_FILE_TYPE_ALL
						? 'Non_Union_VAT-report'
						: state === NEW_NON_UNION_FILE_TYPE_WITH_PAYMENT
							? 'Non_Union_VAT-report_with-issues'
							: state === NEW_NON_UNION_XML_FILE_TYPE_ALL
								? 'Non_Union_VAT-report_XML'
								: state === NEW_NON_UNION_XML_FILE_TYPE_WITH_PAYMENT
									? 'Non_Union_VAT-report_XML_with-issues'
									: '';

		const response: TVatReportFileResponsePayload = yield call(
			api.vatreport.vatReportFile,
			payload,
		);
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		// console.log('vatReportFileWorker', response);
		yield put(vatReportFileSuccess(response));
		if (response) {
			yield fileDownload(
				response.file,
				response.filename,
				// ? `${typeOfFile}_${String(date.getFullYear())}-${String(date.getMonth() + 1)}-${String(
				// 		date.getDate(),
				//   )}_${String(date.getHours())}-${String(date.getMinutes())}.zip`
				// : `${typeOfFile}_${String(date.getFullYear())}-${String(date.getMonth() + 1)}-${String(
				// 		date.getDate(),
				//   )}_${String(date.getHours())}-${String(date.getMinutes())}.xml`,
				// `${typeOfFile}_${String(date.getFullYear())}-${String(date.getMonth() + 1)}-${String(
				// 	date.getDate(),
				// )}_${String(date.getHours())}-${String(date.getMinutes())}.${
				// 	state === NEW_IOSS_FILE_TYPE_ALL || state === NEW_IOSS_FILE_TYPE_WITH_PAYMENT
				// 		? 'xml'
				// 		: state === NEW_NON_UNION_XML_FILE_TYPE_ALL ||
				// 		  state === NEW_NON_UNION_XML_FILE_TYPE_WITH_PAYMENT ||
				// 		  state === NEW_UNION_FILE_TYPE_ALL ||
				// 		  state === NEW_UNION_FILE_TYPE_WITH_PAYMENT
				// 		? 'zip'
				// 		: 'csv'
				// }`,
			);
		}
		// console.log('pathname', window.location.pathname);
		if (window.location.pathname !== PATHS.VAT_REPORT_NEW_PAGE)
			window.location.pathname = PATHS.VAT_REPORT_NEW_PAGE;
		// yield put(settingsInitState());
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

export function* newUnionVATReportRequestWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(api.vatreport.newUnionVATReport);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

export function* newUnionVATReportWithPaymentRequestWorker() {
	try {
		const response: TNewVATReportResponsePayload = yield call(
			api.vatreport.newUnionVATReportWithPayment,
		);
		yield put(newVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

export function* getVatReportsWorker() {
	try {
		const response: TVatReportsResponsePayload = yield call(api.vatreport.getVatReports);
		yield put(getVatReportsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(settingsInitState());
	}
}

export function* swissPostVATReportWorker() {
	try {
		const response: TSwissPostVATReportResponsePayload = yield call(
			api.vatreport.swissPostVATReport,
		);
		yield put(swissPostVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

export function* euDdpVATReportWorker() {
	try {
		const response: TEuDdpVATReportResponsePayload = yield call(api.vatreport.euDdpVATReport);
		yield put(euDdpVATReportSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(settingsInitState());
	}
}

export function* vatReportSaga() {
	yield takeEvery(newIOSSVATReportRequest.type, newIOSSVATReportWorker);
	yield takeEvery(newIOSSVATReportWithPaymentRequest.type, newIOSSVATReportWithPaymentWorker);
	yield takeEvery(vatReportStatusRequest.type, vatReportStatusWorker);
	yield takeEvery(vatReportFileRequest.type, vatReportFileWorker);
	yield takeEvery(newNonUnionVATReportRequest.type, newNonUnionVATReportWorker);
	yield takeEvery(
		newNonUnionVATReportWithPaymentRequest.type,
		newNonUnionVATReportWithPaymentWorker,
	);
	yield takeEvery(newNonUnionVATXmlReportRequest.type, newNonUnionVATXmlReportWorker);
	yield takeEvery(
		newNonUnionVATXmlReportWithPaymentRequest.type,
		newNonUnionVATXmlReportWithPaymentWorker,
	);
	yield takeEvery(newUnionVATReportRequest.type, newUnionVATReportRequestWorker);
	yield takeEvery(
		newUnionVATReportWithPaymentRequest.type,
		newUnionVATReportWithPaymentRequestWorker,
	);
	yield takeEvery(getVatReportsRequest.type, getVatReportsWorker);
	yield takeEvery(swissPostVATReportRequest.type, swissPostVATReportWorker);
	yield takeEvery(euDdpVATReportRequest.type, euDdpVATReportWorker);
}
